import ContentWrapper from '../../../common/ContentWrapper';
import type { FullWidthImage } from '../../../../../types/MiniSiteContents';
import ImageWithFallback from '../../../common/ImageWithFallback';
import isAbsoluteUrl from '../../../../core/helpers/isAbsoluteUrl';
import useRelativeUrl from '../../../../core/hooks/useRelativeUrl';
import Markdown from '../../../common/Markdown/Markdown';

type Props = {
  miniSiteContent: FullWidthImage;
};
const MiniSiteFullWidthImage = ({ miniSiteContent }: Props) => {
  const { contentTitle, title, subTitle, descriptionFirst, descriptionSecond, photoUrl, link } =
    miniSiteContent;
  const { getRelativeUrl } = useRelativeUrl();

  return (
    <ContentWrapper className="w-full">
      {contentTitle && <p className="pb-6 text-title3 font-bold">{contentTitle}</p>}
      <div className="relative min-h-[240px] w-full">
        <ImageWithFallback
          alt="full-width-image-image"
          className="relative rounded-lg"
          src={photoUrl || '/fallback-img-1440x440.png'}
          layout="fill"
          objectFit="cover"
          linkImageWrapperClassName="!static"
          sizes="(max-width: 768px) 100vw, 1280px"
          fallbackSrc="/fallback-img-1440x440.png"
          url={link && (isAbsoluteUrl(link) ? link : getRelativeUrl(link))}
          target={isAbsoluteUrl(link) ? '_blank' : '_self'}
        >
          <>
            <div className="absolute bottom-0 h-60 w-full rounded-xl bg-gradient-to-t from-black" />
            <div className="relative flex size-full flex-col items-center justify-center px-6 py-10">
              <div className="flex w-full flex-col gap-6 text-center text-white sm:w-1/2">
                <div className="flex flex-col gap-2">
                  <p className="text-large font-bold">{title}</p>
                  <p className="text-small">{subTitle}</p>
                </div>
                <div className="flex flex-col gap-2">
                  <p className="font-bold">{descriptionFirst}</p>
                  <Markdown className="text-small">{descriptionSecond || ''}</Markdown>
                </div>
              </div>
            </div>
          </>
        </ImageWithFallback>
      </div>
    </ContentWrapper>
  );
};

export default MiniSiteFullWidthImage;
